import {nonNullable} from '@stencil/type-guards';
import getCheapestRoomData from './get-cheapest-room-data';

export default function calculateRoomPriceData({
  // staticMinPrice,
  roomsDataFromHermes = [],
  hQuery,
}: {
  // staticMinPrice: number | undefined;
  hQuery: HQueryType;
  roomsDataFromHermes: RoomDataType[];
  // dispatch: Dispatch;
}) {
  // PRICE CALCULATION START
  let roomData: SelectedRoomDataType = {};
  const pricedetQParam = hQuery?.pricedet;

  if (
    nonNullable(pricedetQParam) &&
    Array.isArray(pricedetQParam) &&
    pricedetQParam.length &&
    pricedetQParam.split('-')[1]
  ) {
    roomData.roomPrice = Number(pricedetQParam.split('-')[1]);
  } else {
    // roomData.roomPrice = staticMinPrice;
    roomData.roomPrice = 0;
  }
  // make usable selected room data
  if (roomsDataFromHermes.length) {
    const cheapestRoomData = getCheapestRoomData(roomsDataFromHermes);
    roomData.roomPrice = cheapestRoomData.roomPrice;
    roomData.emiData = cheapestRoomData.emiData;
    roomData.tax = cheapestRoomData.tax;
    roomData.roomPriceAfterLogin = cheapestRoomData.roomPriceAfterLogin;
  }

  return roomData;
}
